import { DashboardItemModel, DashboardListModel } from '@/domain/models/dashboard/dashboard-model'

export interface CompanyManagerDashboard {
  getDashboardList(): Promise<CompanyManagerDashboard.Model>
}

export namespace CompanyManagerDashboard {
  export type Model = DashboardListModel
  export type ItemModel = DashboardItemModel
  export const key = 'company-manager-dashboard'
}
